import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import { getLabelMessage } from '@gef-ui/localization/messages';
import Filter from '@gef-ui/material-icons/Filter';

import { useCollapsible } from 'features/common/Subheader/hooks';

import Subheader from '../Subheader';

export const PaperWithToolbar = ({
	children,
	toolbar,
	toggleTitle = getLabelMessage('common:filter'),
	toggleIcon = <Filter />,
	toggledElement,
	collapsibleProps,
	subheaderTitle,
	subTitle,
	toggleFn,
}) => {
	const { visible, handleToggle } = useCollapsible(collapsibleProps);

	const handleToggleFn = useCallback(() => {
		handleToggle();
		!!toggleFn && toggleFn();
	}, [handleToggle, toggleFn]);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={3}>
				{subheaderTitle && <Subheader title={subheaderTitle} subTitle={subTitle} />}
				<Grid container>
					<Grid size={12}>
						<Stack
							spacing={1}
							direction="row"
							sx={{
								justifyContent: 'space-between',
							}}
						>
							{toolbar}
							<Stack spacing={1} direction="row">
								<Divider orientation="vertical" flexItem />
								<Button variant="text" size="small" startIcon={toggleIcon} onClick={handleToggleFn}>
									{toggleTitle}
								</Button>
							</Stack>
						</Stack>
					</Grid>
					<Grid size={12}>
						<Divider sx={{ my: 2 }} />
					</Grid>
					<Grid size={12}>
						<Collapse in={visible}>{toggledElement}</Collapse>
					</Grid>
				</Grid>
				{children}
			</Stack>
		</Paper>
	);
};

PaperWithToolbar.propTypes = {
	children: PropTypes.any,
	collapsibleProps: PropTypes.object,
	subTitle: PropTypes.string,
	subheaderTitle: PropTypes.string,
	toggleFn: PropTypes.func,
	toggleIcon: PropTypes.node,
	toggleTitle: PropTypes.string,
	toggledElement: PropTypes.node,
	toolbar: PropTypes.node,
};

export default PaperWithToolbar;
